import { Spinner, Flex } from '@chakra-ui/react';

const Loading = ({ position }) => {
	return (
		<Flex
			transition={0}
			position={position || 'absolute'}
			w={'100%'}
			h={'100%'}
			zIndex={10}
			justifyContent={'center'}
			alignItems={'center'}
		>
			<Spinner color="#ECC94B" w={'120px'} h={'120px'} thickness="15px" />
		</Flex>
	);
};

export default Loading;
